import {RESPONSE_TYPES} from "../constants";

export class ServerResponse {
    constructor(type, title, message) {
        this.type = type || RESPONSE_TYPES.none;
        this.title = title || "";
        this.message = message || "";
    }
}

export class Settings {
    constructor(result) {
        const { publishableKey, role, isAdmin, paymentHistory } = result.data;

        this.publishableKey = publishableKey;
        this.role = role;
        this.isAdmin = isAdmin;
        this.paymentHistory = paymentHistory;
        this.hasAppcenterPlan = result.data?.ac?.hasAppcenterPlan || false;
        this.hasVRISubscription = result.data?.vri?.hasVRISubscription || false;
        this.hasVDSSubscription = result.data?.vds?.hasVDSSubscription || false;
    }
}
/*
export class VriData {
    constructor(result) {
        const { level, levelName, levelMonths, doesNotExpire, doNotRenew, levels, customerId,
            paymentId, expirationDate, allPaymentMethods, nextRenewalLevelName,
            currentCountOfInspectors, featureLabels } = result.data?.vri;
        this.level = level;
        this.levelName = levelName;
        this.levelMonths = levelMonths;
        this.doesNotExpire = doesNotExpire;
        this.doNotRenew = doNotRenew || false;
        this.currentCountOfInspectors = currentCountOfInspectors;

        this.levels = levels;
        this.allPaymentMethods = allPaymentMethods;
        this.featureLabels = featureLabels;

        if (customerId)
            this.customerId = customerId;
        if (paymentId)
            this.paymentId = paymentId;
        if (expirationDate)
            this.expirationDate = new Date().setTime(expirationDate);
        if (nextRenewalLevelName)
            this.nextRenewalLevelName = nextRenewalLevelName;
    }
}

export class VdsData {
    constructor(result) {
        const { level, levelName, levelMonths, doesNotExpire, doNotRenew, levels, customerId,
            paymentId, expirationDate, allPaymentMethods, nextRenewalLevelName,
            apiLicense } = result.data?.vds;
        this.level = level;
        this.levelName = levelName;
        this.levelMonths = levelMonths;
        this.doesNotExpire = doesNotExpire;
        this.doNotRenew = doNotRenew || false;
        this.apiLicense = apiLicense;

        this.levels = levels;
        this.allPaymentMethods = allPaymentMethods;

        if (customerId)
            this.customerId = customerId;
        if (paymentId)
            this.paymentId = paymentId;
        if (expirationDate)
            this.expirationDate = new Date().setTime(expirationDate);
        if (nextRenewalLevelName)
            this.nextRenewalLevelName = nextRenewalLevelName;
    }
}

export class AppCenterData {
    constructor(result) {
        const { allPaymentMethods, customerId, product,
            price, plans, devLevel, devLevelName, expirationDate,
            doesNotExpire, isClientOfReseller, resellerName,
            resellerEmail, resellerPhone, doNotRenew } = result.data?.ac;

        this.devLevel = devLevel;
        this.devLevelName = devLevelName;
        this.doesNotExpire = doesNotExpire;
        this.isClientOfReseller = isClientOfReseller;
        this.plans = plans;
        this.doNotRenew = doNotRenew || false;
        this.allPaymentMethods = allPaymentMethods || [];

        if (resellerName)
            this.resellerName = resellerName;
        if (resellerEmail)
            this.resellerEmail = resellerEmail;
        if (resellerPhone)
            this.resellerPhone = resellerPhone;

        if (customerId)
            this.customerId = customerId;
        if (expirationDate)
            this.expirationDate = new Date().setTime(expirationDate);
        if (product)
            this.product = new Product(product);
        if (price)
            this.price = new Price(price);
    }
}
*/
export class PaymentMethod {
    constructor(data) {
        this.paymentMethodId = data.paymentMethodId;
        this.last4 = data.last4;
        this.brand = data.brand;
    }
}

export class Product {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.image = data.image;
    }
}

export class Price {
    constructor(data) {
        this.id = data.id;
        this.amount = data.amount;
        this.recurring = data.recurring && new PriceRecurring(data.recurring);
    }
}

export class PriceRecurring {
    constructor(data) {
        this.interval = data.interval;
        this.intervalCount = data.intervalCount;
        this.trialPeriodDays = data.trialPeriodDays;
    }
}